export interface XGSUser {
  address: string;
  alternate_emails: string[];
  alternate_phone_numbers: string[];
  email: string;
  family_name: string;
  given_name: string;
  id: string;
  multifactor: unknown[];
  name: string;
  phone_number: string;
  platformRoles: unknown[];
  primary_email: string;
  primary_phone_number: string;
  roles: string[] | Record<string, unknown>;
  tc_accepted: boolean;
  user_metadata: object;
}

export interface XGSRole {
  id: string;
  name: string;
  description: string;
  permissions: string[];
  customerId?: string;
  userCount?: number;
}

export interface RoleItem {
  roleName: string;
  action: 'ADD' | 'REMOVE';
}

export interface RolePatch {
  roleItems: RoleItem[];
}

export interface UserPermissionModel {
  customer: string;
  role: XGSRole | null;
}

export interface WedecoUserData {
  givenName: string;
  familyName: string;
  emailAddress: string;
  id: string;
  roles: object;
}

export enum OidcConfigIds {
  XGS = 'xgs'
}

export enum OidcCommonValues {
  TAB_DETECTION = 'state'
}
